"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateTypeTranslation = void 0;
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/print/enums");
let TemplateTypeTranslation = class TemplateTypeTranslation {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof enums_1.EPrintTemplates !== "undefined" && enums_1.EPrintTemplates) === "function" ? _a : Object)
], TemplateTypeTranslation.prototype, "templateType", void 0);
TemplateTypeTranslation = __decorate([
    (0, core_1.Component)({
        selector: 'template-type',
        template: `
    <ng-container>
    {templateType, select,
      vehicle-purchase {Ankaufvertrag}
      vehicle-contract {Kaufvertrag (Neuwagen)}
      vehicle-contract-used {Kaufvertrag (Gebrauchtwagen)}
      custom-template {Dokument}
    }
  </ng-container>
  `,
    })
], TemplateTypeTranslation);
exports.TemplateTypeTranslation = TemplateTypeTranslation;
